import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgTwitter = function SvgTwitter(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M24 4.314a9.61 9.61 0 01-2.828.771 4.937 4.937 0 002.163-2.722 9.77 9.77 0 01-3.123 1.195A4.937 4.937 0 0016.62 2c-3.176 0-5.512 2.964-4.794 6.042A13.968 13.968 0 011.68 2.9a4.938 4.938 0 001.52 6.57 4.939 4.939 0 01-2.231-.612c-.053 2.284 1.58 4.416 3.947 4.885a4.875 4.875 0 01-2.223.083 4.92 4.92 0 004.597 3.418A9.942 9.942 0 010 19.285a13.904 13.904 0 007.546 2.208c9.134 0 14.299-7.72 13.989-14.639A9.607 9.607 0 0024 4.314z"
  }));
};

export default SvgTwitter;